/*
defines the data structure for links
 */

/**
 * Defines a link between two model nodes
 */
export default class Link {
    /**
     * makes a new link given a source id, target id, and link id,
     * and optionally strength and distance, which control the forces
     * @param {String} type type of link (used as label)
     * @param {number} source id of the first node to connect
     * @param {number} target id of the second node
     * @param {number} id id of this new link
     * @param {number} [strength] (optional) pull-apart-ability of this link
     * @param {number} [distance] (optional) space between the two nodes in px
     */
    constructor(type, source, target, id, strength = .5, distance = 250) {
        this.type = type;
        this.source = source;
        this.target = target;
        this.id = id;
        this.strength = strength;
        this.distance = distance;
        console.log(`new link model ${this.id} of type ${this.type} between ${this.source} 
                    and ${this.target}`);
    }
}
